import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Actions} from '../../actions';
import {paths} from '../../../common/dictionaries/urls';
import {getMenuItems} from '../../util/menuBuilder';
import './loadingPage.scss';

class LoadingPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'gettingPartyToken': false,
    };
  }

  componentDidMount() {
    const {token} = this.props;
    if (token !== '') {
      this.props.loginLogger();
      this.props.getFavoriteOptions();
      this.props.getPartyToken();
      this.props.getLastLogin();
      this.props.getUserInfo();
      this.setState({
        'gettingPartyToken': true,
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (!this.state.gettingPartyToken && prevProps.token !== '') {
      this.props.loginLogger();
      this.props.getPartyToken();
      this.props.getLastLogin();
      this.props.getUserInfo();
      this.setState({
        'gettingPartyToken': true,
      });
    }

    if (this.props.grantedPermissions && this.props.permissions.length) {
      this.addItemsToMenu(this.props.permissions);
      this.props.navigateTo(paths.Home);
    }

    if (this.props.grantedPermissions && !this.props.permissions.length) {
      this.props.navigateTo(paths.AccessDenied);
    }
  }

  addItemsToMenu(permissions) {
    const availableOptions = getMenuItems(permissions);
    this.props.addItemsToMenu(availableOptions);
  }

  render() {
    return (
      <div className='loading-page'>
        <div className='bouncers'>
          <div className='bounce1' />
          <div className='bounce2' />
          <div className='bounce3' />
          <div className='bounce4' />
          <div className='bounce5' />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'token': state.session.token,
    'permissions': state.session.permissions,
    'grantedPermissions': state.session.grantedPermissions,
  };
};

const {
  getUserInfo,
  loginLogger,
  getLastLogin,
  getPartyToken,
  getFavoriteOptions,
  addItemsToMenu,
  navigateTo,
} = Actions;

export default connect(mapStateToProps, {
  getUserInfo,
  loginLogger,
  getLastLogin,
  getPartyToken,
  getFavoriteOptions,
  addItemsToMenu,
  navigateTo,
})(LoadingPage);
